// Third-party imports
import Glide from "@glidejs/glide"
import Aos from "aos";
// import { TweenMax, Power2 } from "gsap/TweenMax";
import SmoothScroll from "smooth-scroll";

// import 'intersection-observer';
// import 'lazysizes';

// AW component imports
import Animate from "./animate";
import Counter from "./components/counter";
import Applink from "./components/applink";
import leadsRegistration from './leads';


class Site {
    constructor() {
        this.body     = document.body;
        this.wrap     = document.querySelector('.js-wrap');
        this.isSlider = !!document.querySelector('.js-product-slider');

        // Slider init
        if (this.isSlider) {
            this.productSlider = new Glide('.js-product-slider', {
                type: 'carousel',
                startAt: 0,
                gap: 80,
            });
        }

        this.treesCounter = new Counter();
        this.animate      = new Animate();
        this.applink      = new Applink();

        // smooth scroll init
        const scroll = new SmoothScroll('a[href*="#"]', {
            header: '[data-scroll-header]',
            speed: 200,
            updateURL: false
        });

        this.bind();
        // this.resize();
    }



    init() {
        // onScroll animations init
        Aos.init({ offset: 40 });

        this.setAsLoaded();

        this.treesCounter.init();

        leadsRegistration()

        // slider build
        if (this.isSlider) this.productSlider.mount();
    }



    setAsLoaded() {
        this.body.classList.remove('loading');
        this.body.classList.add('is-loaded');

        // slider build
        // if (this.available.sliders) this.sliders.forEach(slider => slider.mount());
    }



    bind() {
        // window.addEventListener('resize', () => this.resize());
        window.addEventListener('beforeunload', () => {
            // this.body.scrollTop = document.documentElement.scrollTop = 0
        });

        this.applink.bind();
    }


    resize() {
        // things to update onResize
    }

}

// window.addEventListener('load', () => {
//     const flagContainer = document.querySelector('.iti__flag-container');
//     const selectedFlag = document.querySelector('.iti__selected-flag');
//     if (flagContainer) {
//       flagContainer.setAttribute('aria-label', 'Country code');
//     }
  
//     if (selectedFlag) {
//       selectedFlag.setAttribute('role', 'button');
//       selectedFlag.setAttribute('aria-haspopup', 'true');
//     }
//   });
function playVideo(){
    document.getElementById('playVideo').onclick = function() {
        document.querySelector('.hero__video-player').classList.add('show');
        document.getElementById('videoContent').setAttribute('src','https://www.youtube.com/embed/D9_JkPRTg1I')
        document.querySelector('body').classList.add('stop-scroll')
    }
    document.getElementById('closeVideo').onclick = function() {
        document.querySelector('.hero__video-player').classList.remove('show');
        document.getElementById('videoContent').removeAttribute('src')
        document.querySelector('body').classList.remove('stop-scroll')
    }
}
window.addEventListener('DOMContentLoaded', () => {
    const AWsite = new Site();
    AWsite.init();
    if(document.getElementById('playVideo')){
        playVideo();
    }
    const playBtn = document.getElementById('play-people-video');
    const playBtns = [... document.getElementsByClassName('video__wrapper')];
    const closeBtn = document.getElementById('close-people-video');
    const videoModal = document.getElementById('people-video');
    const videoPlayer = document.getElementById('play-people-video');

    const disableScroll =  (event) => { 
        event.preventDefault();
        event.stopPropagation();
    }
    
    videoModal.addEventListener('scroll', disableScroll);

    if (playBtns.length > 0) {
        playBtns.forEach(btn => {
            btn.addEventListener('click', () => {
                // document.body.classList.add('disable-scroll');
                videoModal.classList.add('show');
                videoModal.querySelector('iframe').src = btn.getAttribute('data-url');
                videoPlayer.querySelector('video').pause();
                videoModal.addEventListener('scroll', disableScroll);
            });
        });
        // playBtn.addEventListener('click', () => {
        //     document.body.classList.add('disable-scroll');
        //     videoModal.classList.add('show');
        //     videoModal.querySelector('iframe').src = 'https://www.youtube.com/embed/N0HvOj_IeNc?autoplay=1&amp;controls=1&amp;showinfo=0&amp;modestbranding=1&amp;loop=1&amp;fs=0&amp;cc_load_policy=0&amp;iv_load_policy=3&amp;autohide=0&amp;enablejsapi=1&amp;rel=0';
        //     videoPlayer.querySelector('video').pause();
        // });
    }
    if (closeBtn) {
        closeBtn.addEventListener('click', () => {
            document.body.classList.remove('disable-scroll');
            videoModal.classList.remove('show');
            videoModal.querySelector('iframe').src = '';
            videoPlayer.querySelector('video').play();
        });
    }
    if (videoModal) {
        videoModal.addEventListener('click', (event) => {
            if (event.target.nodeName === 'DIV') {
                document.body.classList.remove('disable-scroll');
                videoModal.classList.remove('show');
                videoModal.querySelector('iframe').src = '';
                videoPlayer.querySelector('video').play();
            }
        })
    }

    if (window.location.pathname.includes('graduates')) {
        stepperInit();
        const isMobile = getDeviceType() === "mobile";
        if (isMobile) {
            stepperAnimate();
        }
        const swiper = new Swiper('.swiper', {
            slidesPerView: 2,
            centeredSlides: true,
            loop: true,
            autoplay: {
              delay: 2500,
              disableOnInteraction: false
            },
            spaceBetween: 40
        });
      }
});

const getDeviceType = () => {
    const ua = navigator.userAgent;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
      return "tablet";
    }
    if (
      /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
        ua
      )
    ) {
      return "mobile";
    }
    return "desktop";
  };

function stepperInit() {
    const stepper = document.getElementById('stepper');
    const steps = [... stepper.querySelectorAll('.step')].reverse();
    steps[0].classList.add('active');

    stepper.addEventListener('mouseover', (event) => {
        const isStep = event.target.getAttribute('data-step') || event.target.tagName === 'BUTTON';
        if (isStep) {
            const hoverElement = event.target.closest('.step');
            steps.forEach(step => {
                step.classList.toggle('active', step === hoverElement );
            });
        }
    })
    
}

function stepperAnimate() {
    let observerOptions = {
        rootMargin: '0px',
        threshold: 0.2
    }

    function observerCallback(entries, observer) {
        entries.reverse().forEach(entry => {
            if(entry.isIntersecting) {
                const hoverElement = entry.target.closest('.step');
                entries.reverse().forEach(({ target }) => {
                    target.classList.toggle('active', target === hoverElement );
                });
            }
        });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);
    document.querySelectorAll('.step').forEach((i) => {
        if (i) {
            observer.observe(i);
        }
    });
}




// WEBPACK FOOTER //
// ./src/js/index.js